import { create } from 'zustand';

export interface ProspectiveSiteFilterObject {
	filter_date: { flagged: boolean; startDate: Date | null; endDate: Date | null };
	projectType: string;
	sourceOfSiteLead: string;
	projectClassification: string;
	typeOfConstruction: string;
	type_of_record_c: string;
}

export type ProspectiveSiteSortValue = 'createddate_desc' | 'createddate_asc' | 'sitename' | 'createddate' | '';

const initialProspectiveSiteFilterObject: ProspectiveSiteFilterObject = {
	filter_date: { flagged: false, startDate: null, endDate: null },
	projectType: '',
	sourceOfSiteLead: '',
	projectClassification: '',
	typeOfConstruction: '',
	type_of_record_c: '',
};

interface ProspectiveSiteFilterStore {
	prospectiveSiteFilterObject: ProspectiveSiteFilterObject;
	search: string;
	sortValue: ProspectiveSiteSortValue;
	updateProspectiveSiteFilterObject: (filter: ProspectiveSiteFilterObject) => void;
	updateProspectiveSiteSearch: (search: string) => void;
	updateProspectiveSiteSortValue: (sortValue: ProspectiveSiteSortValue) => void;
	resetProspectiveSiteFilterStore: () => void;
}

export const useProspectiveSiteFilterStore = create<ProspectiveSiteFilterStore>((set) => ({
	prospectiveSiteFilterObject: { ...initialProspectiveSiteFilterObject },
	search: '',
	sortValue: '',
	updateProspectiveSiteFilterObject: (prospectiveSiteFilterObject): void =>
		set(() => ({ prospectiveSiteFilterObject: { ...prospectiveSiteFilterObject } })),
	updateProspectiveSiteSearch: (search): void => set(() => ({ search })),
	updateProspectiveSiteSortValue: (sortValue): void => set(() => ({ sortValue })),
	resetProspectiveSiteFilterStore: (): void =>
		set(() => ({
			prospectiveSiteFilterObject: { ...initialProspectiveSiteFilterObject },
			search: '',
			sortValue: '',
		})),
}));
